import ClientApplication from '../../../api/application/interfaces/ClientApplication'
import { convertAppValuesBase } from '../sharedConvertAppValues'
import {
    coapplicantFieldNames,
    applicantFieldNames,
} from '../sharedInstructions'

export default function convertAppValues(app: ClientApplication) {
    return convertAppValuesBase(app, (data) => ({
        ...data,
        [applicantFieldNames.citizenshipStatus]: app.citizenship_status,
        ...(app.application_type === 'J' && {
            [coapplicantFieldNames.citizenshipStatus]:
                app.coapplicant_citizenship_status,
        }),
    }))
}
